import { render, staticRenderFns } from "./Feature4.vue?vue&type=template&id=6f1b5ba0"
import script from "./Feature4.vue?vue&type=script&lang=js"
export * from "./Feature4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports